import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface FeedbackData {
  id: number;
  feedbackContent: string;
  userId: number;
  subject: string | null;
  createdDate: string;
  userName: string;
  email: string;
  phoneNumber: number;
  isFlagged: boolean;
  userOperatingSystem: number;
}

export const getFeedbackData = async (token: string): Promise<FeedbackData[]> => {
  const baseUrl = getApiBaseUrl();
  const response = await fetch(`${baseUrl}/api/Feedback/(Admin)`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch feedback data: ${response.status}`);
  }

  const data: FeedbackData[] = await response.json();
  return data;
};
